import * as React from "react";
import { cn } from "@/lib/utils";

interface ProgressProps extends Omit<React.ComponentProps<"div">, "value"> {
  value?: number | null;
  max?: number;
}

function Progress({ value = 0, max = 100, className, ...props }: ProgressProps) {
  const safeMax = Number.isFinite(max) && max > 0 ? max : 100;
  const safeValue =
    value === null || !Number.isFinite(value) ? null : Math.min(safeMax, Math.max(0, value));
  const percentage = safeValue === null ? null : (safeValue / safeMax) * 100;
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={safeMax}
      aria-valuenow={safeValue ?? undefined}
      aria-valuetext={safeValue === null ? "Loading" : undefined}
      className={cn("relative h-2 w-full overflow-hidden rounded-full bg-muted", className)}
      {...props}
    >
      <div
        className="h-full rounded-full bg-primary transition-[width]"
        style={{ width: percentage === null ? "35%" : `${percentage}%` }}
      />
    </div>
  );
}

export { Progress };
export type { ProgressProps };
